import { GoalsActionsTypes } from "../constants/actionTypes"
import { IPatientGoal } from "../interfaces/patient/IPatientGoals"
import { IGoalStoreState } from "../interfaces/IAppState"

function init(): IGoalStoreState {
	return null
}
export const goalsReducer = function (state = init(), action: any) {
	switch (action.type) {
		case GoalsActionsTypes.UPDATE_PATIENT_GOALS: {
			return {
				...state,
				patientGoals: action.payload,
			}
		}
		case GoalsActionsTypes.UPDATE_PATIENT_GOALS_LAST_MODIFIED_DATE: {
			return {
				...state,
				lastModifiedDate: action.payload,
			}
		}
		case GoalsActionsTypes.UPDATE_PATIENT_GOALS_METRIC: {
			return {
				...state,
				goalMetrics: action.payload,
			}
		}
		case GoalsActionsTypes.UPDATE_PATIENT_GOAL_DELETED_IDS: {
			return {
				...state,
				patientGoalDeletedIds: [...(state?.patientGoalDeletedIds || []), ...(action?.payload || [])],
			}
		}
		case GoalsActionsTypes.DELETE_PATIENT_GOAL_STATE: {
			return init()
		}
		default:
			return state
	}
}
